import React, { Component } from 'react';
import axiosInstance from '../../utils/axios-instance';

const STATUS = {
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
};

class StripePaymentResult extends Component {
	state = {
		status: STATUS.LOADING,
		paymentInfo: null,
		errorMessage: '',
	};

	componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const sessionId = params.get('session_id');

		if (!sessionId) {
			this.setState({
				status: STATUS.ERROR,
				errorMessage: 'No session ID found. Please try again.',
			});
			return;
		}

		this.fetchPaymentInfo(sessionId);
	}

	fetchPaymentInfo = (sessionId) => {
		axiosInstance
			.get(`/payment-provider/stripe/checkout/session/${sessionId}/status`)
			.then((response) => {
				const data = response.data;
				if (data.success) {
					this.setState({
						status: STATUS.SUCCESS,
						paymentInfo: data,
					});
				} else {
					this.setState({
						status: STATUS.ERROR,
						errorMessage: 'Payment was not completed successfully.',
					});
				}
			})
			.catch((error) => {
				const message =
					error.response?.data?.error?.message ||
					error.response?.data?.message ||
					'Failed to retrieve payment information.';
				this.setState({
					status: STATUS.ERROR,
					errorMessage: message,
				});
			});
	};

	formatCurrency = (amount) => {
		if (amount == null) return '$0.00';
		return '$' + Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	};

	renderLoading() {
		return (
			<div className="text-center">
				<div className="lds-dual-ring" />
				<p style={{ marginTop: '16px', color: '#6c757d' }}>
					Retrieving payment information...
				</p>
			</div>
		);
	}

	renderError() {
		return (
			<div className="text-center">
				<i
					className="far fa-times-circle"
					style={{ fontSize: '48px', color: '#dc3545', marginBottom: '16px' }}
				/>
				<h3>Payment Error</h3>
				<p style={{ color: '#6c757d' }}>{this.state.errorMessage}</p>
			</div>
		);
	}

	renderPaymentInfo() {
		const { paymentInfo } = this.state;
		if (!paymentInfo) return null;

		const isACH = paymentInfo.paymentIntentStatus === 'processing' ||
			(paymentInfo.paymentMethodTypes && paymentInfo.paymentMethodTypes.includes('us_bank_account'));
		const is3DS = paymentInfo.paymentIntentStatus === 'requires_action' &&
			paymentInfo.paymentMethodTypes && paymentInfo.paymentMethodTypes.includes('card');
		const isPaid = paymentInfo.paymentStatus === 'paid' || isACH || is3DS;
		const rowStyle = { display: 'flex', justifyContent: 'space-between', marginBottom: '8px' };

		return (
			<div className="text-center">
				<i
					className={isPaid ? 'far fa-check-circle' : 'far fa-exclamation-circle'}
					style={{ fontSize: '48px', color: isPaid ? '#28a745' : '#ffc107', marginBottom: '16px' }}
				/>
				<h3>{isPaid ? 'Payment Complete' : 'Payment Processing'}</h3>
				<p style={{ color: '#6c757d', marginBottom: '24px' }}>
					{isACH
						? 'Thank you! Your payment transaction is completed.'
						: is3DS
						? 'Thank you! Your payment has been completed.'
						: isPaid
						? 'Thank you! Your payment has been processed.'
						: 'Your payment is being processed. Please check back shortly.'}
				</p>

				<div
					style={{
						background: '#f8f9fa',
						borderRadius: '8px',
						padding: '20px',
						textAlign: 'left',
						maxWidth: '400px',
						margin: '0 auto 24px',
					}}
				>
					{paymentInfo.amountTotal != null && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Amount:</span>
							<span>{this.formatCurrency(paymentInfo.amountTotal)}</span>
						</div>
					)}
					{paymentInfo.amountReceived != null && !isACH && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Amount Received:</span>
							<span>{this.formatCurrency(paymentInfo.amountReceived)}</span>
						</div>
					)}
					{paymentInfo.currency && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Currency:</span>
							<span>{paymentInfo.currency.toUpperCase()}</span>
						</div>
					)}
					{paymentInfo.paymentStatus && !isACH && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Payment Status:</span>
							<span style={{
								color: isPaid ? '#28a745' : '#ffc107',
								fontWeight: '600',
								textTransform: 'capitalize',
							}}>
								{paymentInfo.paymentStatus}
							</span>
						</div>
					)}
					{paymentInfo.paymentIntentStatus && !isACH && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Transaction Status:</span>
							<span style={{ textTransform: 'capitalize' }}>{paymentInfo.paymentIntentStatus}</span>
						</div>
					)}
					{paymentInfo.paymentIntentId && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Transaction ID:</span>
							<span style={{ wordBreak: 'break-all', textAlign: 'right', marginLeft: '12px' }}>
								{paymentInfo.paymentIntentId}
							</span>
						</div>
					)}
					{paymentInfo.accountNumber && (
						<div style={rowStyle}>
							<span style={{ fontWeight: '600' }}>Account #:</span>
							<span>{paymentInfo.accountNumber}</span>
						</div>
					)}
				</div>
			</div>
		);
	}

	render() {
		const { status } = this.state;

		return (
			<div className="cmv-page cmv-page-login">
				<div className="page-wrapper">
					<div className="page-content">
						<main>
							<div className="col col-sm-8 col-md-6 col-xl-4">
								<div className="card-login">
									<div className="card-login-header">
										<div className="brand-container" />

										{status === STATUS.LOADING && this.renderLoading()}
										{status === STATUS.SUCCESS && this.renderPaymentInfo()}
										{status === STATUS.ERROR && this.renderError()}

										{status !== STATUS.LOADING && (
										<p style={{ textAlign: 'center', marginTop: '24px', color: '#6c757d' }}>
											You can close this tab now.
										</p>
									)}
									</div>
								</div>
							</div>
						</main>
					</div>
				</div>
			</div>
		);
	}
}

export default StripePaymentResult;
